// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SsTf","textarea":"styles_textarea__1fGyh"};